import { clearReleaseMarker } from "~/utils/releaseMarker";
import { fetchCurrentRelease, startReleaseReload } from "~/utils/releaseReload";

export default defineNuxtPlugin({
  name: "release-reload",
  enforce: "post",
  setup(nuxtApp) {
    if (import.meta.dev) return;

    const toast = useToast();
    const router = useRouter();
    const { t } = nuxtApp.$i18n as { t: (key: string) => string };
    const monitor = startReleaseReload({
      releaseId: __VERNE_RELEASE_ID__,
      fetchRelease: fetchCurrentRelease,
      href: () => window.location.href,
      replace: (url) => window.location.replace(url),
      notify: (reload, reason) => {
        const notification = {
          id: "frontend-release",
          title: t(reason === "release" ? "frontend-release.title" : "frontend-release.recovery-title"),
          description: t(reason === "release" ? "frontend-release.description" : `frontend-release.${reason}`),
          duration: 0,
          close: false,
          actions: [{ label: t("frontend-release.reload"), onClick: reload }],
        };
        if (toast.toasts.value.some((item) => item.id === notification.id)) {
          toast.update(notification.id, notification);
        } else {
          toast.add(notification);
        }
      },
    });

    nuxtApp.hook("app:mounted", async () => {
      await clearReleaseMarker(router, __VERNE_RELEASE_ID__);
      void monitor.check();
    });
    nuxtApp.hook("app:chunkError", () => {
      void monitor.recoverChunkError();
    });
    nuxtApp.vueApp.onUnmount(monitor.stop);
  },
});
